export class SubscriptionEvent {
    public eventId:string;
    public accountId:string;
    public eventName: string;
    public showEventOnlyIfOptedIn :boolean;
    public eventDescription: string; 
}